module.exports = __webpack_public_path__ + "static/media/IMG_0820.cf31e168.jpg";